// extracted by mini-css-extract-plugin
export default {"cell":"YvIMr","nameText":"w1SRw"};